import React from "react";
import Button from "../shared/button";
import { Title, TextDescription } from "../shared/text/Text";
import styles from './Modal.module.css';
import { modal } from "../modalManagment";

const ModalConfirmDeleteCard = ({ onClick }) => {
    return (
        <div className={styles.containerModal}>
            <Title styles={styles.textModalTitle}>ELIMINAR TARJETA</Title>
            <TextDescription styles={styles.textDescription}>Este tarjeta será eliminada de tu perfil</TextDescription>
            <TextDescription styles={styles.textDescription}>¿Deseas continuar?</TextDescription>
            <div className={styles.containButtons}>
                <Button label="Cancelar" outline styles={styles.buttonMiddle} onClick={() => modal.close()} />
                <Button label="Eliminar" styles={`${styles.buttonMiddle} ${styles.buttonDanger}`} onClick={onClick} />
            </div>
        </div>
    )
}

export default ModalConfirmDeleteCard;